function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent, cloneElement } from 'react';
import classnames from 'classnames';

var TabBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TabBar, _PureComponent);

  function TabBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TabBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChildChange = function (value) {
      var onChange = _this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(value);
      }
    };

    _this.getSelected = function (index, itemKey) {
      var _this$props = _this.props,
          activeKey = _this$props.activeKey,
          defaultActiveKey = _this$props.defaultActiveKey;

      if (!activeKey) {
        if (!defaultActiveKey && index === 0) {
          return true;
        }

        return defaultActiveKey === itemKey;
      }

      return activeKey === itemKey;
    };

    return _this;
  }

  _createClass(TabBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          visible = _this$props2.visible,
          prefixCls = _this$props2.prefixCls,
          children = _this$props2.children,
          style = _this$props2.style;
      var cls = classnames(prefixCls, _defineProperty({}, "".concat(prefixCls, "--hidden"), !visible));
      var items = React.Children.map(children, function (element, index) {
        if (!React.isValidElement(element)) return null;
        return cloneElement(element, {
          key: index,
          disabled: element.props.disabled,
          onChange: function onChange() {
            return _this2.onChildChange(element.props.itemKey);
          },
          badge: element.props.badge,
          title: element.props.title,
          icon: element.props.icon,
          itemKey: element.props.itemKey || index,
          style: element.props.style,
          selected: _this2.getSelected(index, element.props.itemKey)
        });
      });
      return React.createElement("div", {
        className: cls,
        style: style
      }, items);
    }
  }]);

  return TabBar;
}(PureComponent);

TabBar.Item = void 0;
TabBar.defaultProps = {
  prefixCls: 'za-tab-bar',
  visible: true
};
export default TabBar;